<template>
    <div>
        <create-role-form v-if="createdMode" @cancel="createdMode = false" @success="showSuccess"
            @error="showError"></create-role-form>

        <role-table v-else ref="table" @add-role="createdMode = true">
        </role-table>
    </div>
</template>
<script>
import RoleTable from './RoleTable'
import CreateRoleForm from './CreateRoleForm'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'roles',
    mixins: [popupMixins, permissionsMixins],
    components: {
        RoleTable,
        CreateRoleForm,
    },
    data() {
        return {
            componentName: this.$translate('role'),
            createdMode: false,
            importModal: false,
        }
    },
    mounted() {
        // this.$refs.table.doSearch() // this page initialization code is inside RoleTable.vue
    },

    methods: {
        hideModal() {
            this.createdMode = false
            this.importModal = false
            this.$refs.table.doSearch()
        },
        showAddModal() {
            this.$refs.modal.showModal()
        },
        showImportModal() {
            this.importModal = true
        },
        showError(error) {
            // if (error === 'Duplicate Name!') {
            this.genericToast(
                this.componentName,
                this.$translate('error'),
                'danger',
                `${error}`
            )
        },

        showSuccess(action) {
            console.log('Attempt Emit')
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${this.componentName} ${this.$translate('create_alert')}`
            )
            this.createdMode = false
        },
    },
}
</script>
<style></style>
